var maps = [];
var geocoder;

jQuery(document).ready(function($){
	try {
		$('.gmap').each(function () {
			init_map($(this));
		});
	} catch (e) {
		console.log(e);
	}
});

function init_map( mapWrapper ) {
	$markers = mapWrapper.find('.marker').detach();

	var mapIndex = maps.length + 1;
	var map = maps[mapIndex] = L.map(mapWrapper[0]).setView([49.8, 15.6], 7);
	L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
		maxZoom: 19,
		attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	}).addTo(map);

	// add markers
	var markers = L.markerClusterGroup({ showCoverageOnHover: false });
	var points = [];
	$markers.each(function() {
		if ($(this).attr('data-lat') && $(this).attr('data-lng')) {
			var args = {};
			if ($(this).attr('data-icon')) {
				args.icon = L.icon({
					iconUrl: $(this).attr('data-icon'),
					iconSize: [32, 32],
					iconAnchor: [9, 32],
					popupAnchor: [0, 0]
				})
			}

			var marker = L.marker(
				[$(this).attr('data-lat'), $(this).attr('data-lng')],
				args
			).bindPopup($(this).html());

			markers.addLayer(marker)
			points.push(marker.getLatLng());
		}
	});

	map.addLayer(markers);
	map.fitBounds(L.latLngBounds(points));
}
